import * as React from 'react';
import { ComponentProps } from '../common';
import styles from './paper.scss';

export const Paper = (props:ComponentProps) => (
  <div className={`container ${styles.paperStyle} ${props.className}`} id={props.componentId}>
    {props.children}
  </div>
);
